import {
  CARELEVEL_UPDATE_ANSWER,
  CARELEVEL_UPDATE_INPUT_VALUES,
  CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS,
} from '@/store/actions/careLevelCalculator';
import { SHOW_MODULE_OVERVIEW_PAGES } from '@/views/CareLevelCalculator/Wizard/Wizard';

export default {
  mounted() {
    document.addEventListener('keyup', this.hitKey);
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.hitKey);
  },

  watch: {
    hitKeyOrder: function () {
      this.compareArrays(this.hitKeyOrder, this.desiredKeyOrder);
    },
  },

  data() {
    return {
      hitKeyOrder: [],
      desiredKeyOrder: [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
    };
  },

  methods: {
    hitKey(event) {
      switch (event.keyCode) {
        case 38:
          this.hitKeyOrder.push(38);
          break;
        case 39:
          this.hitKeyOrder.push(39);
          break;
        case 37:
          this.hitKeyOrder.push(37);
          break;
        case 40:
          this.hitKeyOrder.push(40);
          break;
        case 65:
          this.hitKeyOrder.push(65);
          break;
        case 66:
          this.hitKeyOrder.push(66);
          break;
        default:
          this.hitKeyOrder = [];
      }
    },

    compareArrays(a, b) {
      const processedStringB = JSON.stringify(b).replace(/[[\]]/g, '');
      if (JSON.stringify(a).includes(processedStringB)) {
        this.fillCLCW();
      }
    },

    fillCLCW() {
      this.hitKeyOrder = [];
      const activeWizardAnswers = [
        {
          currentModule: 0,
          question: 0,
          index: 1,
        },
        {
          currentModule: 0,
          question: 1,
          index: 2,
        },
        {
          currentModule: 0,
          question: 2,
          index: 3,
        },
        {
          currentModule: 0,
          question: 3,
          index: 0,
        },
        {
          currentModule: 0,
          question: 4,
          index: 1,
        },
        {
          currentModule: 1,
          question: 0,
          index: 1,
        },
        {
          currentModule: 1,
          question: 1,
          index: 2,
        },
        {
          currentModule: 1,
          question: 2,
          index: 1,
        },
        {
          currentModule: 1,
          question: 3,
          index: 3,
        },
        {
          currentModule: 1,
          question: 4,
          index: 2,
        },
        {
          currentModule: 1,
          question: 4,
          index: 1,
        },
        {
          currentModule: 1,
          question: 5,
          index: 2,
        },
        {
          currentModule: 1,
          question: 6,
          index: 1,
        },
        {
          currentModule: 1,
          question: 7,
          index: 1,
        },
        {
          currentModule: 1,
          question: 8,
          index: 2,
        },
        {
          currentModule: 1,
          question: 9,
          index: 1,
        },
        {
          currentModule: 1,
          question: 10,
          index: 1,
        },
        {
          currentModule: 2,
          question: 0,
          index: 1,
        },
        {
          currentModule: 2,
          question: 1,
          index: 0,
        },
        {
          currentModule: 2,
          question: 2,
          index: 0,
        },
        {
          currentModule: 2,
          question: 3,
          index: 1,
        },
        {
          currentModule: 2,
          question: 4,
          index: 2,
        },
        {
          currentModule: 2,
          question: 5,
          index: 2,
        },
        {
          currentModule: 2,
          question: 6,
          index: 1,
        },
        {
          currentModule: 2,
          question: 7,
          index: 2,
        },
        {
          currentModule: 2,
          question: 8,
          index: 0,
        },
        {
          currentModule: 2,
          question: 9,
          index: 3,
        },
        {
          currentModule: 2,
          question: 10,
          index: 2,
        },
        {
          currentModule: 2,
          question: 11,
          index: 1,
        },
        {
          currentModule: 2,
          question: 12,
          index: 1,
        },
        {
          currentModule: 3,
          question: 0,
          index: 0,
        },
        {
          currentModule: 3,
          question: 1,
          index: 1,
        },
        {
          currentModule: 3,
          question: 2,
          index: 2,
        },
        {
          currentModule: 3,
          question: 3,
          index: 3,
        },
        {
          currentModule: 3,
          question: 4,
          index: 2,
        },
        {
          currentModule: 3,
          question: 5,
          index: 1,
        },
        {
          currentModule: 3,
          question: 6,
          index: 0,
        },
        {
          currentModule: 3,
          question: 7,
          index: 1,
        },
        {
          currentModule: 3,
          question: 8,
          index: 2,
        },
        {
          currentModule: 3,
          question: 9,
          index: 1,
        },
        {
          currentModule: 3,
          question: 10,
          index: 1,
        },
        {
          currentModule: 3,
          question: 11,
          index: 3,
        },
        {
          currentModule: 3,
          question: 12,
          index: 1,
        },

        {
          currentModule: 4,
          question: 0,
          index: 1,
        },
        {
          currentModule: 4,
          question: 1,
          index: 2,
        },
        {
          currentModule: 4,
          question: 2,
          index: 1,
        },
        {
          currentModule: 4,
          question: 3,
          index: 1,
        },
        {
          currentModule: 4,
          question: 4,
          index: 1,
        },
        {
          currentModule: 4,
          question: 5,
          index: 2,
        },
        {
          currentModule: 4,
          question: 6,
          index: 2,
        },
        {
          currentModule: 4,
          question: 7,
          index: 3,
        },
        {
          currentModule: 4,
          question: 8,
          index: 0,
        },
        {
          currentModule: 4,
          question: 9,
          index: 1,
        },
        {
          currentModule: 4,
          question: 10,
          index: 2,
        },
        {
          currentModule: 4,
          question: 11,
          index: 1,
        },
        {
          currentModule: 4,
          question: 12,
          index: 2,
        },
        {
          currentModule: 4,
          question: 13,
          index: 2,
        },
        {
          currentModule: 4,
          question: 14,
          index: 0,
        },
        {
          currentModule: 4,
          question: 15,
          index: 1,
        },
        {
          currentModule: 5,
          question: 0,
          index: 0,
        },
        {
          currentModule: 5,
          question: 1,
          index: 1,
        },
        {
          currentModule: 5,
          question: 2,
          index: 2,
        },
        {
          currentModule: 5,
          question: 3,
          index: 3,
        },
        {
          currentModule: 5,
          question: 4,
          index: 2,
        },
        {
          currentModule: 5,
          question: 5,
          index: 1,
        },
      ];
      const activeCounterInputValues = [1, 1, 1, 1, 1, 1, 3, 4, 1, 3, 3, 3, 1, 1, 1, 1];
      const overViewRadioButtons = [
        {
          currentModule: 0,
          contentIdx: 0,
          value: 1,
        },
        {
          currentModule: 1,
          contentIdx: 0,
          value: 1,
        },
        {
          currentModule: 2,
          contentIdx: 0,
          value: 1,
        },
        {
          currentModule: 3,
          contentIdx: 0,
          value: 1,
        },
        {
          currentModule: 4,
          contentIdx: 0,
          value: 1,
        },
        {
          currentModule: 4,
          contentIdx: 1,
          value: 1,
        },
        {
          currentModule: 4,
          contentIdx: 2,
          value: 1,
        },
        {
          currentModule: 5,
          contentIdx: 0,
          value: 1,
        },
      ];

      activeWizardAnswers.forEach((answer) => {
        this.$store.dispatch(CARELEVEL_UPDATE_ANSWER, {
          currentModule: answer.currentModule,
          question: answer.question,
          index: answer.index,
        });
      });
      overViewRadioButtons.forEach((answer) => {
        if (SHOW_MODULE_OVERVIEW_PAGES) {
          this.$store.dispatch(CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS, {
            currentModule: answer.currentModule,
            contentIdx: answer.contentIdx,
            value: answer.value,
          });
        }
      });

      activeCounterInputValues.forEach((answer, index) => {
        this.$store.dispatch(CARELEVEL_UPDATE_INPUT_VALUES, {
          question: index,
          value: answer,
        });
      });

      this.hitKeyOrder = [];
    },
  },
};
